module.exports = __webpack_public_path__ + "img/image21.f5e8e3ad.png";